import {Action} from "redux";
import {IClientCustomerActionCreator} from "../action/client_customer_action";
import {GetCustomerRequest} from "../request/customer_request";

interface IClientCustomerDispatcher {
    getCustomer(item: GetCustomerRequest): void;
}

class Dispatcher implements IClientCustomerDispatcher {

    constructor(private dispatch: (action: Action) => void,
                private actionCreator: IClientCustomerActionCreator) {

    }

    public getCustomer = (item: GetCustomerRequest): void => {
        this.dispatch(this.actionCreator.requestGetCustomerAction(item));
    }

}

const createClientCustomerDispatcher = (dispatch: (action: Action) => void, actionCreator: IClientCustomerActionCreator): IClientCustomerDispatcher => {
    return new Dispatcher(dispatch, actionCreator);
};

export {IClientCustomerDispatcher, createClientCustomerDispatcher};



// WEBPACK FOOTER //
// ./src/presentation/dispatcher/client_customer_dispatcher.ts